import { TextCodes } from '@api/types/translation/TextCodes';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import { Box, styled } from '@mui/material';
import { t } from '@translations';

export type PaginationProps = {
  start?: number;
  end?: number;
  totalCount?: number;
  itemsPerPage?: number;
  onNext?: Function;
  onPrev?: Function;
  isWorking: boolean;
};

const StyledBox = styled(Box)`
  background: #e6eced;
  height: auto;
  display: flex;
  align-items: center;
`;

const Arrow = styled(Box)`
  display: inline-flex;
  height: 52px;
  width: 52px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

/**
 * Pagination component
 */
export const Pagination = ({
  itemsPerPage = 1,
  start = 0,
  totalCount = 0,
  onNext = () => null,
  onPrev = () => null,
  isWorking,
}: PaginationProps) => {
  const currentPage = Math.ceil(start / itemsPerPage) + 1;
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const hasNextPage = currentPage < totalPages;
  return (
    <StyledBox>
      <Box sx={{ p: 2 }}>
        {t(TextCodes.Search.PaginationRowsPerPage, {
          rowsPerPage: itemsPerPage.toString(),
        })}
      </Box>
      {!isWorking && (
        <>
          <Box sx={{ ml: 'auto', mr: 2, p: 2 }}>
            <Box sx={{ mr: 2, display: 'inline-block' }}>
              {t(TextCodes.Search.PaginationResults, { totalCount: totalCount.toString() })}
            </Box>
            {totalPages > 0 && (
              <Box sx={{ display: 'inline-block' }}>
                {t(TextCodes.Search.PaginationCurrentPage, {
                  currentPage: currentPage.toString(),
                  totalPages: totalPages.toString(),
                })}
              </Box>
            )}
          </Box>
          {totalPages > 1 && (
            <Box>
              <Arrow onClick={() => onPrev()} sx={{}}>
                <ArrowLeft />
              </Arrow>
              {hasNextPage && (
                <Arrow onClick={() => onNext()}>
                  <ArrowRight />
                </Arrow>
              )}
            </Box>
          )}
        </>
      )}
    </StyledBox>
  );
};
